import { resolveEntryApr } from '../../yields/intrinsic/resolveYieldApr'
import type { SavingsRegistryEntry } from './registry'

/**
 * Runs every yield source referenced by a savings-registry slice and
 * returns a flat `address → apr%` map.
 *
 * A thin wrapper over the shared {@link resolveEntryApr} core — savings
 * entries need no protocol-specific composition (every APR is a direct
 * fetcher-key lookup), unlike `lst/yieldBinding.ts` which adds the weETH
 * case. Dedup by fetcher ref (Angle stUSD+stEUR, Sky sUSDS+stUSDS, Maple
 * syrup* all share one upstream call) lives in the shared core.
 *
 * Returns `{ [shareAddressLowercase]: aprPercent }`. Missing keys become
 * `0` downstream — never `undefined`.
 */
export const resolveYieldApr = async (
  entries: SavingsRegistryEntry[],
): Promise<Record<string, number>> => (await resolveEntryApr(entries)).apr
